import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Layouts
import { FullLayoutComponent } from './layouts/full-layout.component';
import { BlankLayoutComponent } from './layouts/blank-layout.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'administrations/list',
    pathMatch: 'full',
  },
  {
    path: '',
    component: FullLayoutComponent,
    data: {
      title: 'HOME'
    },
    children: [
      {
        path: 'dashboard',
        loadChildren: './dashboard/dashboard.module#DashboardModule'
      },
      {
        path: 'administrations',
        loadChildren: './administrations/administrations.module#AdministrationsModule'
      },
      {
        path: 'community',
        loadChildren: './communities/communities.module#CommunitiesModule'
      },
      {
        path: 'publications',
        loadChildren: './publications/publications.module#PublicationsModule'
      },
      {
        path: 'administration-community',
        loadChildren: './reports/administration-community/administration-community.module#AdministrationCommunityModule'
      },
      {
        path: 'report-emails',
        loadChildren: './reports/report-emails/report-emails.module#ReportEmailsModule'
      },
      {
        path: 'permissions',
        loadChildren: './permissions/permissions.module#PermissionsModule'
      },
      {
        path: 'tools',
        loadChildren: './tools/tools.module#ToolsModule'
      },
    ]
  },
  {
    path: '',
    component: BlankLayoutComponent,
    data: {
      title: 'Blank'
    },
    children: [
      {
        path: '',
        loadChildren: './_guards/guards.module#GuardsModule',
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts